import { isHdl, getDeviceId } from '@haidilao-private/jsbridge';

/**
 * @description: 计算像素
 * @param {number} num 尺寸
 * @return {*}
 */
export const $vw = function (num: number) {
  return (num / 375) * 100 + 'vw';
};
/**
 * @description: 防止按钮重复点击
 * @param {object} fn 执行函数
 * @param {number} time 几秒执行一次  默认500ms
 * @return {*}
 */
export const throttle = (fn: any, time = 500) => {
  let timeout: any = null;
  return function (this: any, ...args: any) {
    if (!timeout) {
      fn.apply(this, args);
      timeout = setTimeout(() => {
        timeout = null;
      }, time);
    }
  };
};
/**
 * @description: 是否是android终端
 */
export const isAndroid =
  navigator.userAgent.indexOf('Android') > -1 ||
  navigator.userAgent.indexOf('Adr') > -1;

// 端外 设置导航栏标题（微信）
export const setDocumentTitle = (title: string) => {
  try {
    const document = window.document;
    document.title = title;
  } catch (err) {
    console.log(err);
  }
};

/**
 * @description:判断环境
 * env ： app   mini小程序    wx
 */
export function isEnv() {
  // try {
  //   const ua = navigator.userAgent.toLowerCase();
  //   let env = 'H5';
  //   if (isHdl) {
  //     //是否是app环境
  //     env = 'App';
  //   } else if (ua.indexOf('micromessenger') !== -1) {
  //     //微信环境
  //     window.wx.miniProgram.getEnv((res: any) => {
  //       // 小程序环境下逻辑
  //       if (res.miniprogram) env = 'MiniApp';
  //       //非小程序环境下逻辑
  //       else env = 'H5';
  //     });
  //   }
  //   return env;
  // } catch (err) {
  //   console.log(err);
  //   return 'H5'; //默认h5
  // }
  try {
    let env = '';
    if (isHdl) {
      //是否是app环境
      env = 'App';
    } else {
      //非微信环境
      env = getQuery('source') || 'H5';
    }
    return env;
  } catch (err) {
    console.log(err);
    return 'H5'; //默认h5
  }
}

// 判断是否有网络
export const isOnLine = () => {
  let netStatus = '';
  if (window.navigator.onLine == true) {
    netStatus = 'onLine'; //网络链接正常
  } else {
    netStatus = 'offLine'; //网络连接失败
  }
  return netStatus;
};
/**
 * 获取url query
 * @export
 * @param {*} getQuery
 * @returns
 */
export const getQuery = (paramName: string) => {
  const hash = decodeURIComponent(location.hash);
  const search = decodeURIComponent(location.search);
  let queryStr = search.substr(1); // search参数
  if (hash.split('?')[1]) queryStr += '&' + hash.split('?')[1]; // +query参数
  const query: any = {};
  queryStr &&
    queryStr.split('&').forEach((item) => {
      const tmp = item.split('=');
      query[tmp[0]] = tmp[1];
    }); // 拼接全部路由参数
  return paramName ? query[paramName] : query;
};

/**
 * 获取设备ID
 */
export const getDeviceIds = () => {
  return new Promise((resolve, reject) => {
    getDeviceId((res: any) => {
      if (res.deviceId) {
        resolve(res.deviceId);
      } else {
        reject('设备id获取失败');
      }
    });
  });
};

/**
 *
 * @param name 存储名字
 * @param value 存储值
 * @param expiresTime 到期时间（毫秒）
 */
export const setStorage = (name: string, value: any, expiresTime?: number) => {
  if (!expiresTime) {
    const time = new Date();
    expiresTime = time.getTime() + 1000 * 60 * 60;
  }
  window.sessionStorage.setItem(
    name,
    JSON.stringify({ value: value, expiresTime: expiresTime }),
  );
};
